import React from 'react';
import clsx from 'clsx';

interface ProgressBarProps {
  value: number;
  max?: number;
  label?: string;
  tone?: 'accent' | 'success' | 'warning' | 'danger' | 'gold';
  size?: 'sm' | 'md' | 'lg';
  showValue?: boolean;
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max = 100,
  label,
  tone = 'accent',
  size = 'md',
  showValue,
  className,
}) => {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className={clsx('ui-progress', `ui-progress--${size}`, className)} role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={max} aria-label={label}>
      {label && <div className="ui-progress__label"><span>{label}</span>{showValue && <span className="ui-progress__value">{Math.round(pct)}%</span>}</div>}
      <div className="ui-progress__track">
        <div className={clsx('ui-progress__fill', `ui-progress__fill--${tone}`)} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
